import useTracker from './useTracker';

const Tracker = () => {
  useTracker();

  return false;
};

export default Tracker;
